import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=0405046f"
import script from "./IconEdit.vue?vue&type=script&lang=ts"
export * from "./IconEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports